function TmdbScore({score, info}) {
    // card with the score from TMDB using stars

    const totalStars = 10;
    const mult = 1;

    const renderStars = () => {
        const stars = [];
        //round score to nearest 0.5
        let scoreRounded = Math.round(score * mult * 2) / 2;
        for (let i = 0; i < totalStars * mult; i++) {
            if (i < Math.floor(scoreRounded)) {
                // Estrella completa
                stars.push(<i key={i} className="fa-solid fa-star ms-2"></i>);
            } else if (i < Math.ceil(scoreRounded)) {
                // Media estrella
                stars.push(<i key={i} className="fa-solid fa-star-half-alt ms-2"></i>);
            } else {
                // Estrella vacía
                stars.push(<i key={i} className="fa-regular fa-star ms-2"></i>);
            }
        }
        return stars;
    };

    return (
        <div className="text-center mt-3">
            <div className="card-body">
                <img height={10} src="https://files.readme.io/29c6fee-blue_short.svg"/>
                <p className="card-text">
                    {renderStars()}
                </p>
            </div>
            {info}
        </div>
    )
}

export default TmdbScore;
